import countries from '../../../assets/images/countries.jpg'
import todo from '../../../assets/images/todo.jpeg'
import books from '../../../assets/images/books.jpg'
import cards3 from '../../../assets/images/cards3.jpg'
export const works = [
    {
        id: 1,
        title: 'Countries',
        img: countries,
        description: 'React TypeScript Redux-toolkit Redux-thunk  Scss',
        linkDeploy: 'https://yanakorobova.github.io/countries/',
    },
    {
        id: 2,
        title: 'TodoList',
        img: todo,
        description: 'React TypeScript Redux-toolkit  Redux-thunk Rest-API  Mui Scss Storybook Formik',
        linkDeploy: 'https://yanakorobova.github.io/todolist/'
    },
    {
        id: 3,
        title: 'Learning cards',
        img: cards3,
        description: 'React TypeScript Redux  Redux-thunk Rest-API Mui Scss Formik',
        linkDeploy: 'https://alexander-gladkikh.github.io/cards/#/login',
    },
    {
        id: 4,
        title: 'Books Library',
        img: books,
        description: 'React TypeScript Redux Redux-toolkit Redux-thunk Rest-API  Scss AntDesign',
        linkDeploy: 'https://yanakorobova.github.io/books/',
    }
]